import { createAsyncThunk } from '@reduxjs/toolkit'
import { AxiosClient } from 'src/redux/AxiosClient'

export const getReviewAndSummaryAsync = createAsyncThunk(
  'pcb/getReviewAndSummaryAsync',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/pcb-configurator/get-summaryTable-data', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
      isRejectWithErrorMsg: true,
    })
  },
)

export const getPCBDetailsAsync = createAsyncThunk(
  'pcb/getPCBDEtails',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/pcb-configurator/get-all-pcbs', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

export const createNewPCB = createAsyncThunk(
  'pcb/create-new-pcb',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/pcb-configurator/create-new-pcb', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

export const updatePCBDetails = createAsyncThunk(
  'pcb/update-pcb-details',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient('POST', '/v1/pcb-configurator/update-pcb-details', payload, {
      dispatch,
      rejectWithValue,
      fulfillWithValue,
    })
  },
)

export const pcbTopBottomLayerData = createAsyncThunk(
  'pcb/pcb-top-bottom-layer-data',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient(
      'GET',
      '/v1/pcb-configurator/get-material-and-processing-cost-filter',
      payload,
      {
        dispatch,
        rejectWithValue,
        fulfillWithValue,
      },
    )
  },
)

export const addPcbMaterialCostDetails = createAsyncThunk(
  'pcb/add-pcb-material-cost-details',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient(
      'POST',
      '/v1/pcb-configurator/add-pcb-material-cost-details',
      payload,
      {
        dispatch,
        rejectWithValue,
        fulfillWithValue,
      },
    )
  },
)

export const addPcbProcessingCostDetails = createAsyncThunk(
  'pcb/add-pcb-processing-cost-details',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient(
      'POST',
      '/v1/pcb-configurator/add-pcb-processing-cost-details',
      payload,
      {
        dispatch,
        rejectWithValue,
        fulfillWithValue,
      },
    )
  },
)

export const addPcbAdditionalCostDetails = createAsyncThunk(
  'pcb/add-pcb-additional-cost-details',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient(
      'POST',
      '/v1/pcb-configurator/add-pcb-additional-cost-details',
      payload,
      {
        dispatch,
        rejectWithValue,
        fulfillWithValue,
      },
    )
  },
)

export const getPreviousPCBDetails = createAsyncThunk(
  'pcb/previous-pcb-details',
  async (payload, { dispatch, rejectWithValue, fulfillWithValue }) => {
    return await AxiosClient(
      'POST',
      '/v1/pcb-configurator/previous-selection-details',
      payload,
      {
        dispatch,
        rejectWithValue,
        fulfillWithValue,
      },
    )
  },
)